import React from "react";
import { useStateValue } from "./StateProvider";
import Player from "./Player";
import SummaryDetail from "./SummaryDetail";
import SkinsDetail from "./SkinsDetail";
import SummaryMoney from "./SummaryMoney";
import { useHistory } from "react-router-dom";
import "./Summary.css";
import firebase from "firebase";
//import { auth } from "./firebase";
//import { db } from "./firebase";

function Summary() {
  const history = useHistory();
  const [{ players }] = useStateValue();
  const [{ scores }] = useStateValue();
  const [, reset] = useStateValue();
  const [{ lowfront }] = useStateValue();
  const [{ lowback }] = useStateValue();
  const [{ eventDate }] = useStateValue();

  const getPlayerScoresF9 = (id) => {
    const playerscores = scores.filter((s) => s.id === id && s.hole <= 9);
    return playerscores.length === 9 ? playerscores : [];
  };
  const getPlayerScoresB9 = (id) => {
    const playerscores = scores.filter((s) => s.id === id && s.hole >= 10);
    return playerscores.length === 9 ? playerscores : [];
  };
  const getPlayerScores18 = (id) => {
    const playerscores = scores.filter((s) => s.id === id);
    return playerscores.length === 18 ? playerscores : [];
  };
  const getTotal = (selScores) => {
    //console.log("empty array length",selScores.length)
    if (!selScores.length == 0) {
      const Total = selScores?.reduce(
        (totalStrokes, score) => totalStrokes + score.strokes,
        0
      );
      return Total;
    } else {
      return "N/A";
    }
  };

  // console.log ("Gambling",players.filter((s) => s.isSubmitted === true).length > 0)

  const saveGame = () => {
    const d = new Date();

    players.map((player) => {
      const t =
        eventDate +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds() +
        ":" +
        d.getMilliseconds();
      const playerscores = scores.filter((s) => s.id === player.id);
      // create array of scores
      let scoring = {};
      playerscores.map((score) => (scoring["H" + score.hole] = score.strokes));

      firebase
        .firestore()
        .collection("events")
        .doc(eventDate)
        .collection("scores")
        .doc(player.name)
        .update({
          scoressent: t,
          tfront: getTotal(getPlayerScoresF9(player.id)),
          tback: getTotal(getPlayerScoresB9(player.id)),
          total18: getTotal(getPlayerScores18(player.id)),
          scoring,
        })
        .then(function () {
          console.log("Document successfully written!");
        })
        .catch(function (error) {
          console.error("Error writing document: ", error);
        });
      return false;
    });
  };

  const cleargame = () => {
    reset({
      type: "RESET",
    });

    localStorage.removeItem("scores");
    localStorage.removeItem("overs");
    localStorage.removeItem("netovers");
    localStorage.removeItem("skins");
    localStorage.removeItem("dogmeat");
    localStorage.removeItem("teammatch");
    localStorage.removeItem("players");
    localStorage.removeItem("sums");
    localStorage.removeItem("todaysEvent");
    localStorage.removeItem("lowfront");
    localStorage.removeItem("lowback");
    localStorage.removeItem("hole");
    history.push("/setup");
  };

  return (
    <div className="game__summary">
      <div className="title__bar">
        <h1 className="title">Game Summary</h1>
        <button onClick={cleargame} className="cleargame">
          Clear
        </button>
        <button className="savegame" onClick={saveGame}>
          Save Game
        </button>
      </div>
      <h2 className="subTitle">Scoring</h2>
      <div className="players__summary">
        <div>
          {players.map((player) => (
            <div key={player.id} className="player__summary">
              <div className="player__name">
                <Player id={player.id} />
              </div>
              <div className="scoring">
                <SummaryDetail id={player.id} />
                <div className="winnersnine">
                  {player.id === lowfront[0] ? (
                    <span className="lowFront">Low Front</span>
                  ) : (
                    ""
                  )}
                  {player.id === lowback[0] ? (
                    <span className="lowBack">Low Back</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {players.filter((s) => s.inGroupSkins === true).length > 0?(   
      <>
      <h2 className="subTitle">Skins & Dog Meat</h2>
      <SkinsDetail />
      </>):""}
      {players.filter((s) => s.isSubmitted === true).length > 0?(   
      <>     
      <SummaryMoney/>
      </>):""}
     
      
      
    </div>
  );
}

export default Summary;
